export const PRO15_END = Date.parse("2026-11-02T22:00:00Z");
export const pro15Active = () => Date.now() < PRO15_END;
